export const singleSignIn = () => () => Promise.resolve(false);

export const getStatus = () => Promise.reject();

export const exchangePlatformToken = () => Promise.reject();
